export default "__VITE_ASSET__Ddx77BiQ__"